import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { MaterialLeftStyleTabTitle } from "../../../../Constants/Constants";
import { MaterialLeftSubTitle } from "../../../../Data/UiKits/Tabs";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import MaterialContent from "./MaterialContent";
import MaterialLeftNav from "./MaterialLeftNav";

const MaterialLeftStyleTab = () => {
  const [basicTab, setBasicTab] = useState("1");
  return (
    <Col xxl="6">
      <Card>
        <CommonCardHeader title={MaterialLeftStyleTabTitle} span={MaterialLeftSubTitle} />
        <CardBody>
          <div className="tabs-responsive-side">
            <div className="material-wrapper">
              <MaterialLeftNav basicTab={basicTab} setBasicTab={setBasicTab} />
              <div className="material-content">
                <MaterialContent tabId={basicTab} />
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default MaterialLeftStyleTab;
